export function getScoreColor(score) {
  if (score < 0 || score > 100) {
    throw new Error("Score must be between 0 and 100");
  }

  if (score >= 85) {
    return "#00A74F";
  } else if (score >= 65) {
    return "#E9B511";
  } else if (score >= 45) {
    return "#E9B511";
  } else if (score >= 35) {
    return "#F8931F";
  } else {
    return "#ED1B24";
  }
}

export function getSatisfactionColor(value) {
  switch (value) {
    case "Excellent":
      return "#00A74F";
    case "Good":
      return "#E9B511";
    case "Satisfactory":
      return "#E9B511";
    case "Needs Improvement":
      return "#F8931F";
    case "Failed":
      return "#ED1B24";
    default:
      return "#ED1B24";
  }
}

export function getImportanceColor(value) {
  switch (value) {
    case "high":
      return "#ED1B24";
    case "medium":
      return "#E9B511";
    case "low":
      return "#00A74F";
    default:
      return "#00A74F";
  }
}

export async function convertToBase64(url) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve) => {
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting image:", error);
    return null;
  }
}
